import { setVisibility } from '@philips-emr/hpms-components';
import { FetchAPI, PanelAPI } from '@philips-emr/tws-components';
import { FieldListAPI } from '@philips-emr/tws-components/lib/components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnAfterFetch, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, TissAliases } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.TISS })
export default class TissController extends BaseController {

  private panels: { [key in string]?: PanelAPI } = {};

  @OnMount([
    TissAliases.PANEL_QUIMIO,
    TissAliases.PANEL_QUIMIO_DIAGNOSTICO,
    TissAliases.PANEL_QUIMIO_CID,
    TissAliases.PANEL_RADIO,
    TissAliases.PANEL_RADIO_DIAGNOSTICO,
    TissAliases.PANEL_RADIO_CID,
    TissAliases.PANEL_OPME,
    TissAliases.PANEL_SITUACAO_INICIAL,
  ])
  onMount({ target }: MountEvent): void {
    const api = target as PanelAPI;
    this.panels[api.getAlias().replace('panel-', 'fetch-')] = api;
  }

  @OnMount(TissAliases.FIELD_LIST_ODONTO)
  onMountListFieldSituacaoClinica(event: MountEvent): void {
    const api = event.target as FieldListAPI;
    const { nrSeqBeneficiario } = HistoryService.getCurrentRouteParams();
    const { origem, nrSeq } = this.context.getBulkData();

    void HttpService.get<Record<string, Value>[]>(Endpoints.GET.SITUACAO_CLINICA, { nrSeqBeneficiario, origem, nrSeq })
      .then(({ body }) => {
        if (body) {
          api.setValue(body);
        }
      });
  }

  @OnAfterFetch([
    TissAliases.FETCH_QUIMIO,
    TissAliases.FETCH_QUIMIO_DIAGNOSTICO,
    TissAliases.FETCH_QUIMIO_CID,
    TissAliases.FETCH_RADIO,
    TissAliases.FETCH_RADIO_DIAGNOSTICO,
    TissAliases.FETCH_RADIO_CID,
    TissAliases.FETCH_OPME,
    TissAliases.FETCH_SITUACAO_INICIAL,
  ])
  onQuimioAfterFetch = (event: FetchEvent): void => setVisibility(event, this.panels[(event.target as FetchAPI).getAlias()]);
}
